import { render, staticRenderFns } from "./MlocalidadModals.vue?vue&type=template&id=0e18a63d"
import script from "./MlocalidadModals.vue?vue&type=script&lang=js"
export * from "./MlocalidadModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports